<div class="bar-wrapper">

  <div class="bar-container">
    <div class="bar" [style.width.%]="progress"></div>
  </div>

</div>
